import { ReactNode } from 'react';
import { usePermissionsStore } from '../../stores/permissions.store';
import ForbiddenPage from '../../pages/ForbiddenPage';

interface Props {
  perms: string | string[];
  mode?: 'any' | 'all';
  children: ReactNode;
}

/**
 * Route-level guard. Renders ForbiddenPage in place when user lacks the
 * required perm(s) — URL is retained so a refresh/back works naturally and
 * bookmarks aren't rewritten to /403.
 */
export function RouteGuard({ perms, mode = 'any', children }: Props) {
  const { loaded, isOwner, isSuperAdmin, permissions } = usePermissionsStore();
  if (!loaded) return null; // waiting on /auth/me/permissions

  if (isOwner || isSuperAdmin) return <>{children}</>;

  const list = Array.isArray(perms) ? perms : [perms];
  const held =
    mode === 'all'
      ? list.every((p) => permissions.has(p))
      : list.some((p) => permissions.has(p));

  if (!held) return <ForbiddenPage />;
  return <>{children}</>;
}
